// src/components/QuetionModal.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { TreeSelect, Select, Button, Form, Modal, Input, Row, Col, Upload, AudioFilled, Radio, Textarea, InputNumber, UploadImg, DatePicker } from '../../ui/ot';
import { useTranslation } from 'react-i18next';
import { createContext } from 'react';
import { useContext } from 'react';
import { useRef } from 'react';


const LanguageContext = createContext(null)

const RenewSettingModal = ({
    keyPrefix = "library.backstage.Circulation.RenewSetting.borrowed_list",
    axiosMode = "post",
    propsForm,
    propsOpen = null,
    propsLoading = null,
    propsSetOpen = () => {

    },
    onFinish = () => {

    },
    reloadTable = () => { },
    modalStyle = {},
    openButtonStyle = {
        backgroundColor: "#fff8c8",
        color: "#000"
    },
    customFormItems = () => { },
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const axiosModelanguage = {
        post: t('post'),
        patch: t('edit')
    }
    const [form] = Form.useForm();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const [formReloadCount, setFormReloadCount] = useState(0)
    const showModal = () => {
        setFormReloadCount(pre => pre + 1)
        if (propsOpen === null) {
            setIsModalOpen(true);
        }
        else {
            propsSetOpen(true)
        }
    };
    const closeModal = () => {
        if (propsOpen === null) {
            setIsModalOpen(false);
        }
        else {
            propsSetOpen(false)
        }
    }

    const handleOk = () => {
        setLoading(true)
        if (propsForm) {
            propsForm.submit()
        }
        else {
            form.submit()
        }
    };

    const handleCancel = () => {
        closeModal()
    };
    const onFormFinish = (values) => {
        onFinish(values)
    }
    useEffect(() => {
        setFormReloadCount(pre => pre + 1)
    }, [propsOpen])


    return (<>
        <LanguageContext.Provider value={keyPrefix}>
            {
                propsOpen === null &&
                <Button type="primary" onClick={showModal}>
                    {
                        `${axiosModelanguage[axiosMode]}資料`
                    }
                </Button>
            }

            <Modal
                style={{ top: 10, }}
                contentStyle={{ padding: 16 }}
                // width={1000}
                title={`${axiosModelanguage[axiosMode]}資料`}
                open={propsOpen === null ? isModalOpen : propsOpen}
                onOk={handleOk}
                okText={t('ok')}
                cancelText={t('cancel')}
                onCancel={handleCancel}
                confirmLoading={propsLoading === null ? loading : propsLoading}
                maskClosable={false}
            >
                <Row
                >
                    <Col span={24}>
                        <RenewSettingForm
                            formReloadCount={formReloadCount}
                            open={propsOpen === null ? isModalOpen : propsOpen}
                            axiosMode={axiosMode}
                            propsForm={propsForm ? propsForm : form}
                            onFormFinish={onFormFinish}
                            customFormItems={customFormItems}                            
                        />
                    </Col>
                </Row>
            </Modal>
        </LanguageContext.Provider>
    </>);
};
export default RenewSettingModal;



const RenewSettingForm = ({
    keyPrefix = "library.backstage.Circulation.RenewSetting.borrowed_list",
    propsForm,
    formReloadCount = 0,
    onFormFinish = () => { },
    propsOnValuesChange = () => { },
    fieldName,
    initialValues,
    hasValue = false,
    customFormItems = () => {},
    defaultValue = {},
    ...props
}) => {
    const keyPrefix_ = useContext(LanguageContext)
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix_ || keyPrefix })
    const [categoryId, setTaskId] = useState()
    const [form] = Form.useForm();
    const setFormValuesOtherThings = (formValues) => {
        // 做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }
    }
    const getFormValues = () => {
        let values = {}
        if (propsForm) {
            values = propsForm.getFieldsValue()
        }
        else {
            values = form.getFieldsValue()
        }
        return values
    }
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = () => {
        const values = getFormValues();
        onFormFinish({
            ...values,
        })
    }
    const onValuesChange = (e, { name, ...props }) => {
        let formValues = null
        if (fieldName) {
            if (propsForm) {
                formValues = propsForm.getFieldValue(fieldName)
            }
            else {
                formValues = form.getFieldValue(fieldName)
            }
        } else {
            if (propsForm) {
                formValues = propsForm.getFieldsValue()
            }
            else {
                formValues = form.getFieldsValue()
            }
        }
        propsOnValuesChange({
            ...formValues,
            // ...e
        })
    }

    const getAnyFormValue = (name, count = 0) => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, [])
    useEffect(() => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    useEffect(() => {
        (propsForm ?? form).setFieldsValue({ ...defaultValue })
    }, [defaultValue])


    return <>
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            {/* <Row gutter={[8, 8]}>
                                <Col span={24}>
                                    <Form.Item
                                        hidden={true}
                                        name={fieldName ? [fieldName, "key"].join('.') : "key"}
                                    >
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('borrowernumber')}
                                        name={fieldName ? [fieldName, "borrowernumber"].join('.') : "borrowernumber"}
                                        rules={!hasValue ? [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('itemnumber')}
                                        name={fieldName ? [fieldName, "itemnumber"].join('.') : "itemnumber"}
                                        rules={!hasValue ? [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <Input disabled={hasValue} />
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={t('issue_date_due')}
                                        name={fieldName ? [fieldName, "issue_date_due"].join('.') : "issue_date_due"}
                                        rules={!hasValue ? [
                                            {
                                                required: true,
                                                message: "請輸入"
                                            }
                                        ] : []}
                                    >
                                        <DatePicker.Time />
                                    </Form.Item>
                                </Col>
                            </Row> */}
                            <FormItemComponent
                                keyPrefix={keyPrefix}
                                field={fieldName}
                                initialValues={initialValues}
                                // options={options}
                            />
                            {customFormItems && customFormItems(fieldName, (propsForm ?? form).getFieldsValue(), onValuesChange, propsForm ?? form)}
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    </>
}
export { RenewSettingForm }

const FormItemComponent = ({ 
    keyPrefix, 
    field, 
    initialValues = {}, 
    options, 
    hasValue = false,
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    return (
        <Row gutter={[8, 8]}>
            <Col span={24}>
                <Row>
                    <Col span={24}>
                        <Form.Item
                            hidden={true}
                            {...field}
                            name={[field?.name ?? '', 'key']}
                            fieldKey={[field?.fieldKey ?? '', 'key']}
                            label={`${t('key')}`}
                            initialValue={initialValues?.key}
                        >
                            <Input />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'issue_id']}
                            fieldKey={[field?.fieldKey ?? '', 'issue_id']}
                            label={`${t('issue_id')}`}
                            initialValue={initialValues?.issue_id}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <Input disabled/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            {...field}
                            name={[field?.name ?? '', 'due_date']}
                            fieldKey={[field?.fieldKey ?? '', 'due_date']}
                            label={`${t('due_date')}`}
                            initialValue={initialValues?.due_date}
                            rules={!hasValue ? [
                                {
                                    required: true,
                                    message: "請輸入"
                                }
                            ] : []}
                        >
                            <DatePicker />
                        </Form.Item>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};